module.exports = __webpack_public_path__ + "static/media/loader.3d8da044.svg";